import {
  generateImportColumn,
  importErrorFunction,
} from "../../../../../utils/commonFunctions";

// function for tier 1 to be used in ag-grid to display errors
const importTier1ErrorFunction = (value: any) => {
  return {
    tooltipValueGetter: (params: any) => {
      if (params.data.errors && Object.hasOwn(params.data.errors, value)) {
        return params?.data?.errors[value]?.toString();
      } else {
        return params.value;
      }
    },
    cellStyle: (params: any) => {
      if (params.data.errors && Object.hasOwn(params.data.errors, value)) {
        return { color: "white", backgroundColor: "red" };
      }
      return null;
    },
  };
};

// columns for General Questions used in import component
export const colDefsGeneral = (initialOption: any) => {
  return [
    {
      ...generateImportColumn("", `type`),
      filter: "agSetColumnFilter",
      minWidth: 100,
      maxWidth: 150,
      ...importErrorFunction(),
      cellRenderer: (props: any) => {
        const modified = initialOption.interest_assessment_type.find(
          (data: any) => data.id == props.value
        )?.title;
        return modified;
      },
      valueFormatter: (props: any) => {
        const modified = initialOption.interest_assessment_type.find(
          (data: any) => data.id == props.value
        )?.title;
        return modified;
      },
      tooltipValueGetter: (props: any) => {
        const modified = initialOption.interest_assessment_type.find(
          (data: any) => data.id == props.value
        )?.title;
        return modified;
      },
    },
    {
      ...generateImportColumn("", `code`),
      minWidth: 100,
      ...importErrorFunction(),
    },
    {
      ...generateImportColumn("", `question`),
      minWidth: 150,
      ...importErrorFunction(),
    },
    {
      ...generateImportColumn("", `industry_name`),
      minWidth: 150,
      ...importErrorFunction(),
    },
    {
      ...generateImportColumn("", `career_categories`),
      minWidth: 150,
      cellRenderer: (props: any) => {
        return props.data?.[`career_categories`]?.toString();
      },
      filter: "agTextColumnFilter",
      ...importErrorFunction(),
    },
    {
      ...generateImportColumn("", `occupational_groups`),
      minWidth: 150,
      cellRenderer: (props: any) => {
        return props.data?.[`occupational_groups`]?.toString();
      },
      filter: "agTextColumnFilter",
      ...importErrorFunction(),
    },
  ];
};

// columns for Tier 1 used in import component
export const colDefsTier1 = (initialOption: any) => {
  return [
    {
      ...generateImportColumn("", `type`),
      minWidth: 150,
      filter: "agSetColumnFilter",
      ...importErrorFunction(),
      cellRenderer: (props: any) => {
        const modified = initialOption.interest_assessment_type.find(
          (data: any) => data.id == props.value
        )?.title;
        return modified;
      },
      valueFormatter: (props: any) => {
        const modified = initialOption.interest_assessment_type.find(
          (data: any) => data.id == props.value
        )?.title;
        return modified;
      },
      tooltipValueGetter: (props: any) => {
        const modified = initialOption.interest_assessment_type.find(
          (data: any) => data.id == props.value
        )?.title;
        return modified;
      },
    },
    {
      ...generateImportColumn(
        "Career Category",
        `career_category_display`
      ),
      ...importTier1ErrorFunction(
        "career_category"
      ),
    },
    {
      ...generateImportColumn(
        "Occupational Group",
        `occupational_group_display`
      ),
      ...importTier1ErrorFunction(
        `occupational_group`
      ),
    },
    {
      ...generateImportColumn("", `code`),
      ...importErrorFunction(),
    },
    {
      ...generateImportColumn("", `question`),
      ...importErrorFunction(),
    },
    {
      ...generateImportColumn("", `industry_name`),
      ...importErrorFunction(),
    },

    {
      ...generateImportColumn(
        ``,
        `career_path`
      ),
      ...importErrorFunction(),


    },

    //entry level
    // {
    //   ...generateImportColumn(
    //     `CAREER PATH ID: Entry-Level Career ACP List`,
    //     `career_path_id:_entry-level_career_acp_list_display`
    //   ),
    //   cellRenderer: (props: any) => {
    //     return props.data?.[
    //       `career_path_id:_entry-level_career_acp_list_display`
    //     ]?.toString();
    //   },
    //   filter: "agTextColumnFilter",
    //   ...importTier1ErrorFunction(`entry_level_cp_id`),
    // },
    // {
    //   ...generateImportColumn(
    //     `Education/Training Entry-Level ACP`,
    //     `education/training_entry-level_acp_display`
    //   ),
    //   ...importTier1ErrorFunction(`education/training_entry-level_acp`),
    // },
    // {
    //   ...generateImportColumn(
    //     `Experience Entry-Level`,
    //     `experience_entry-level_display`
    //   ),
    //   ...importTier1ErrorFunction(`experience_entry-level`),
    // },

    // //mid level
    // {
    //   ...generateImportColumn(
    //     `CAREER PATH ID: Mid-Level Career ACP List`,
    //     `career_path_id:_mid-level_career_acp_list_display`
    //   ),
    //   cellRenderer: (props: any) => {
    //     return props.data?.[
    //       `career_path_id:_mid-level_career_acp_list_display`
    //     ]?.toString();
    //   },
    //   filter: "agTextColumnFilter",
    //   ...importTier1ErrorFunction(`mid_level_cp_id`),
    // },
    // {
    //   ...generateImportColumn(
    //     `Education/Training Mid-Level ACP`,
    //     `education/training_mid-level_acp_display`
    //   ),
    //   ...importTier1ErrorFunction(`education/training_mid-level_acp`),
    // },
    // {
    //   ...generateImportColumn(
    //     `Experience Mid-Level`,
    //     `experience_mid-level_display`
    //   ),
    //   ...importTier1ErrorFunction(`experience_mid-level`),
    // },

    // //advanced individual level
    // {
    //   ...generateImportColumn(
    //     "CAREER PATH ID: Advanced Individual-Level Career ACP List",
    //     `career_path_id:_advanced_individual-level_career_acp_list_display`
    //   ),
    //   cellRenderer: (props: any) => {
    //     return props.data?.[
    //       `career_path_id:_advanced_individual-level_career_acp_list_display`
    //     ]?.toString();
    //   },
    //   filter: "agTextColumnFilter",
    //   ...importTier1ErrorFunction(`adv_ind_level_cp_id`),
    // },

    // // advanced level 
    // {
    //   ...generateImportColumn(
    //     "Education/Training Advanced-Level ACP",
    //     `education/training_advanced-level_acp_display`
    //   ),
    //   ...importTier1ErrorFunction(`education/training_advanced-level_acp`),
    // },
    // {
    //   ...generateImportColumn(
    //     "Experience Advanced-Level",
    //     `experience_advanced-level_display`
    //   ),
    //   ...importTier1ErrorFunction(`experience_advanced-level`),
    // },

    // //advanced director level
    // {
    //   ...generateImportColumn(
    //     "CAREER PATH ID: Advanced Director-Level Career ACP List",
    //     `career_path_id:_advanced_director-level_career_acp_list_display`
    //   ),
    //   cellRenderer: (props: any) => {
    //     return props.data?.[
    //       `career_path_id:_advanced_director-level_career_acp_list_display`
    //     ]?.toString();
    //   },
    //   filter: "agTextColumnFilter",
    //   ...importTier1ErrorFunction(`adv_dir_level_cp_id`),
    // },
    // {
    //   ...generateImportColumn(
    //     "Education Advanced Director-Level ACP",
    //     `education_advanced_director-level_acp_display`
    //   ),
    //   ...importTier1ErrorFunction(`education_advanced_director-level_acp`),
    // },
    // {
    //   ...generateImportColumn(
    //     "Experience Advanced Director-Level",
    //     `experience_advanced_director-level_display`
    //   ),
    //   ...importTier1ErrorFunction(`experience_advanced_director-level`),
    // },
    {
      ...generateImportColumn(
        "Skill Category",
        `skill_category_display`
      ),
      ...importTier1ErrorFunction("skill_category"),
    },
  ];
};
